import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { generatePath, useNavigate, useParams } from 'react-router-dom';

import { ParkingSpotReadModel } from '@client/api';
import { isDefinedString, TableCell, TableRow, Text, useAreaMetricString } from '@client/toolkit';

import { PortfolioPaths } from '../../portfolio.router';

interface ParkingSpotsListItemProps {
  parkingSpot?: ParkingSpotReadModel;
  isFetching?: boolean;
}

export const ParkingSpotsListItem = ({ parkingSpot, isFetching }: ParkingSpotsListItemProps) => {
  const navigate = useNavigate();
  const { t: tType } = useTranslation('type');
  const { buildingId } = useParams<{ buildingId: string }>();

  const areaMetric = useAreaMetricString(parkingSpot?.area);

  const handleClick = useCallback(() => {
    if (!parkingSpot?.id || !buildingId) return;

    navigate(
      generatePath(PortfolioPaths.Space, {
        buildingId,
        spaceId: parkingSpot.id,
        discriminator: 'ParkingSpot',
      }),
    );
  }, [parkingSpot?.id, buildingId, navigate]);

  return (
    <TableRow onClick={handleClick} hover={!!parkingSpot?.id}>
      <TableCell loading={isFetching} className="font-bold">
        <Text isEmpty={!isDefinedString(parkingSpot?.name)}>{parkingSpot?.name}</Text>
      </TableCell>
      <TableCell loading={isFetching}>
        <Text isEmpty={!isDefinedString(parkingSpot?.type)}>
          {parkingSpot?.type ? tType(`ParkingSpotType.${parkingSpot.type}`) : '-'}
        </Text>
      </TableCell>
      <TableCell loading={isFetching}>
        <Text isEmpty={!isDefinedString(areaMetric)}>{areaMetric}</Text>
      </TableCell>
    </TableRow>
  );
};
